import {IconName} from '../../libs/shared/ui/src/components/icon/icon';
import {ThemeReader} from '../../libs/shared/ui/src/theme/userThemeProvider';
import {CardModel} from '../models/api/cardModel';
import {isEnhancedGlobalCard, isEnhancedPrivateCard} from './models/cardHelpers';

interface CardNamespaceIconDetails {
  name: IconName;
  findColor: ThemeReader;
}

export const getCardNamespaceIconDetails = (card: CardModel): CardNamespaceIconDetails | undefined => {
  if (isEnhancedGlobalCard(card)) {
    return {
      name: 'buildingFilledTiny',
      findColor: (theme) => theme.palette.teal.shade40,
    };
  }
  if (isEnhancedPrivateCard(card)) {
    return {
      name: 'lockFilledNewTiny',
      findColor: (theme) => theme.greys.shade80,
    };
  }
  return undefined;
};
